/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import '../public/dashboad.css';
import { useNavigate } from 'react-router-dom';
import { customStyles } from '../../components/datatable/customStyles';
import DataTable from 'react-data-table-component';
import { clients_services } from '../../services/clients_services';
import QRCode from 'react-qr-code';
import { dashboad } from '../../services/Dashboad';
import toast from 'react-hot-toast';
const CompanyDashboad = () => {
    const navigate = useNavigate();
    // navigation 
    const home = () => {
        navigate('/company/dashboad');
    };
    const list_scanhistory = () => {
        navigate('/company/list/scanhistory');
    };
    const list_client = () => {
        navigate('/company/list/client');
    };
    const scan_code = () => {
        navigate('/company/scanner');
    };
    const client_waiting = () => {
        navigate('/company/list/clientWaiting');
    };

    // declarations
    const [id, setId] = useState('')
    const [state, setState] = useState(0)
    const [wait, setWait] = useState(true)
    const [filteredData, setFilteredData] = useState([]);
    const [totalClientLoyal, setTotalClientLoyal] = useState('');
    const [clientAleatoireRes, setClientAleatoireRes] = useState('');
    const [totalClient, setTotalClient] = useState('');
    const [tauxClientFidele, setTauxClientFidele] = useState('');
    const [sortGender, setSortGender] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [sortFilter, setSortFilter] = useState('');
    const [clientd, setClientd] = useState({})
    const [client, setClient] = useState({})
    const [searchText, setSearchText] = useState('');
    const [loyalCustomer, setLoyalCustomer] = useState([]);
    const [typeIntervention, setTypeIntervention] = useState('');
    const [isModalAddOpen, setIsModalAddOpen] = useState(false);

    // detail client info
    useEffect(() => {
        if (id !== '') {
            clients_services.getClient(id)
                .then((res) => {
                    // console.log("ClientDetailRes:", res.data.client);
                    setTypeIntervention(res.data.typeIntervention)
                    setClientd(res.data.client)
                })
                .catch((err) => {
                    console.log(err)
                    if (err.response) {
                        if (err.response.status === 400) {
                            navigate("/auth/loginCompany");
                            // swal({
                            //     text: "Votre séssion a expiré, veillez vous connecter",
                            //     icon: "error",
                            //     button: "Fermer",
                            // });
                        }
                        if (err.response.status === 404) {
                            toast("Client introuvable")
                        }
                        if (err.response.status === 500) {
                            toast.error("Erreur d'exécution dans l'application , veillez vous reconnecter.")
                        }
                    }
                })
        }
    }, [id]);

    // get all client function
    const customerLoyal = () => {
        dashboad.customerLoyal()
            .then((res) => {
                // console.log("customerLoyalRes : ", res.data )
                setLoyalCustomer(res.data.listClientFidele
                )
            })
            .catch((err) => {
                console.log(err)
                if (err.response) {
                    if (err.response.status === 400) {
                        navigate("/auth/loginCompany");
                        // swal({
                        //     text: "Votre séssion a expiré, veillez vous connecter",
                        //     icon: "error",
                        //     button: "Fermer",
                        // });
                    }
                    if (err.response.status === 404) {
                        toast("Clients introuvable")
                    }
                    if (err.response.status === 500) {
                        toast.error("Erreur d'exécution dans l'application , veillez vous reconnecter.")
                    }
                }
            })
    }

    // Retrieve the clients when the component is mounted and each time the sorting/filtering criteria change
    useEffect(() => {
        customerLoyal();
    }, [sortOrder, sortFilter, sortGender, state]);

    // Définir les colonnes du tableau
    const columns = [
        {
            name: '#',
            selector: (row, index) => index + 1,
            width: '60px',
            sortable: true,
        },
        // {
        //     name: 'Nom',
        //     selector: (row) => row.nom,
        //     sortable: true,
        // },
        {
            name: 'Prénom',
            selector: (row) => row.prenom,
            sortable: true,
        },
        // {
        //     name: 'Localisation',
        //     selector: (row) => row.localisation,
        //     sortable: true,
        // },
        {
            name: 'Téléphone',
            selector: (row) => row.numeroTel,
            sortable: true,
        },
        {
            name: 'Genre',
            selector: (row) => row.sexe,
            sortable: true,
        },
        {
            name: 'conso.',
            selector: (row) => row.intervention,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row) => (
                <div className='action-container d-flex'>
                    <button className="btn btn-primary btn-xs" title='Voir plus de detail' data-toggle="modal" data-target="#modal-detail" onClick={() => setId(row.id)} ><i className="fas fa-eye " /></button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    // Function to filter and sort client based on current status
    const getClientsSortAdnfilter = () => {
        let clientsFilters = loyalCustomer

        // Apply gender filter
        if (sortGender) {
            clientsFilters = clientsFilters.filter((loyalCustomer) => loyalCustomer.sexe === sortGender);
        }

        // sort clients info
        clientsFilters.sort((a, b) => {
            if (sortOrder === 'desc') {
                if (sortFilter === 'nom') {
                    return b.nom.localeCompare(a.nom);
                } else if (sortFilter === 'prenom') {
                    return b.prenom.localeCompare(a.prenom);
                } else if (sortFilter === 'localisation') {
                    return b.localisation.localeCompare(a.localisation);
                }
            } else {
                if (sortFilter === 'nom') {
                    return a.nom.localeCompare(b.nom);
                } else if (sortFilter === 'prenom') {
                    return a.prenom.localeCompare(b.prenom);
                } else if (sortFilter === 'localisation') {
                    return a.localisation.localeCompare(b.localisation);
                }
            }
        });

        return clientsFilters
    }

    // get total of client loyal
    useEffect(() => {
        dashboad.nbrClientFidels()
            .then((res) => {
                // console.log("totalClientLoyal :: ", res.data)
                setTotalClientLoyal(res.data.nbrClientFidels)
            })
            .catch((err) => {
                console.log(err)
                if (err.response) {
                    if (err.response.status === 400) {
                        navigate("/auth/loginCompany");
                        // swal({
                        //     text: "Votre séssion a expiré, veillez vous connecter",
                        //     icon: "error",
                        //     button: "Fermer",
                        // });
                    }
                    if (err.response.status === 404) {
                        toast("Utilisateur introuvable")
                    }
                    if (err.response.status === 500) {
                        toast.error("Erreur d'exécution dans l'application , veillez vous réconnecter.")
                    }
                }
            })
    }, []);
    // get Client Aleatoire
    useEffect(() => {
        dashboad.nbrClientAleatoire()
            .then((res) => {
                // console.log("clientAleatoireRes :: ", res.data)
                setClientAleatoireRes(res.data.nbrClientAleatoire)
            })
            .catch((err) => console.log(err))
    }, []);
    // get total of client
    useEffect(() => {
        dashboad.totalClient()
            .then((res) => {
                // console.log("totalClientRes :: ", res.data.nbrClient)
                setTotalClient(res.data.nbrClient)
            })
            .catch((err) => console.log(err))
    }, []);
    // get taux Client Fidele
    useEffect(() => {
        dashboad.tauxClientFidele()
            .then((res) => {
                // console.log("tauxClientFideleRes :: ", res.data.pourcentageClient)
                setTauxClientFidele(res.data.pourcentageClient)
            })
            .catch((err) => console.log(err))
    }, []);
    // Mettre à jour les données filtrées et triées chaque fois que l'un des états change
    useEffect(() => {
        const sortedFilteredClients = getClientsSortAdnfilter();
        setFilteredData(sortedFilteredClients);
    }, [loyalCustomer, sortOrder, sortFilter, sortGender]);

    // Filtrer les données en fonction du texte de recherche
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);
        // console.log("value -------> ", value);
        const filtered = getClientsSortAdnfilter().filter(item => {

            return (
                item.nom.toLowerCase().includes(value.toLowerCase()) ||
                item.prenom.toLowerCase().includes(value.toLowerCase()) ||
                item.localisation.toLowerCase().includes(value.toLowerCase())
            );
        });
        setFilteredData(filtered);
    };

    // put client into qr code 
    const clientInfo = JSON.stringify({
        Id: clientd.id,
        Nom: clientd.nom,
        Prenom: clientd.prenom,
        Telephone: clientd.numeroTel,
        Localisation: clientd.localisation,
        Intervention1: clientd.intervention1,
        Intervention2: clientd.intervention2,
        Sexe: clientd.sexe,
        DateCreation: clientd.createdAt,
        Structure: clientd.StructureId,
        Bonus: clientd.bonus
    });

    // add client function
    const onChangeAdd = (e) => {
        setClient({
            ...client,
            [e.target.name]: e.target.value
        })
    }

    const closeAddModal = () => {
        setIsModalAddOpen(false);
    };
    const handleClient = (e) => {
        e.preventDefault();

        if (
            !client.nom ||
            !client.numeroTel ||
            !client.localisation ||
            !client.prenom ||
            !client.sexe
        ) {
            toast.error("Veillez remplir tous les champs obligatoires!");
            return;
        }

        if (client.numeroTel && client.numeroTel.length !== 9) {
            toast.error("Le numéro de téléphone doit contenir 9 chiffres.");
            return;
        }

        if (client.nom && client.nom.length > 50) {
            toast.error("Le champ nom ne doit pas etre au dela de 50 caracteres.");
            return;
        }

        if (client.prenom && client.prenom.length > 50) {
            toast.error("Le champ prenom ne doit pas etre au dela de 50 caracteres.");
            return;
        }

        setWait(false);

        clients_services.addClient(client)
            .then((res) => {
                console.log("clientRes :", res);
                if (res.status === 201) {
                    navigate("/company/list/client");
                    setState((current) => current + 1)
                    toast.success("Client ajouté avec succès.");
                    // Fermer la modal
                    closeAddModal();
                    const backdrop = document.querySelector(".modal-backdrop");
                    if (backdrop) {
                        backdrop.remove();
                    }

                    setClient({
                        nom: "",
                        prenom: "",
                        localisation: "",
                        numeroTel: "",
                        sexe: "",
                    });
                    setWait(true);
                }
            })
            .catch((err) => {
                setWait(true);
                console.log("err : ", err);
                if (err.response) {
                    if (err.response.status === 400) {
                        navigate("/auth/loginCompany");
                        // swal({
                        //     text: "Votre séssion a expiré, veillez vous connecter",
                        //     icon: "error",
                        //     button: "Fermer",
                        // });
                    }
                    if (err.response.status === 404) {
                        toast("Utilisateur introuvable")
                    }

                    if (err.response.status === 500) {
                        toast.error("Erreur d'exécution dans l'application , veillez vous reconnecter.")
                    }
                }
            });
    }

    return (
        <div>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Tableau de bord</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item active link"><a onClick={home}>Acceuil</a></li>
                                    <li className="breadcrumb-item active">Structure</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row first-row">
                            <div className="col-lg-6 col-12 mb-3">
                                <div
                                    className="small-box  big-box bg-info link text-center"
                                    title="Ajouter un client"
                                    data-toggle="modal"
                                    data-target="#modal-add"
                                    onClick={() => setIsModalAddOpen(true)}
                                >
                                    <div className="innerr">
                                        <h3 className="text-bold">Ajouter un client</h3>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-plus" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-6 mb-3">
                                <div
                                    className="small-box big-box bg-success text-center link"
                                    onClick={scan_code}
                                    title="Cliquer pour scanner le code QR"
                                >
                                    <div className="innerr">
                                        <p className="text-bold">Scanner le Code QR</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-qrcode" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-6 mb-3">
                                <div
                                    className="small-box big-box bg-success text-center link"
                                    onClick={list_scanhistory}
                                    title="Cliquer pour voir l'historique du scan"
                                >
                                    <div className="innerr">
                                        <p className="text-bold">Historique du scan</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-history" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-info link" onClick={list_client} title="Liste de clients">
                                    <div className="inner">
                                        <h3>{totalClient ? totalClient : 0}</h3>
                                        <p className="text-bold" >Total clients</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-info link" onClick={home} title="Liste des clients fidèles">
                                    <div className="inner">
                                        <h3>{totalClientLoyal ? totalClientLoyal : 0}</h3>
                                        <p className="text-bold" >Clients fidèles</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-handshake" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-success link" onClick={client_waiting} title="Liste des clients en attentes">
                                    <div className="inner">
                                        <h3>{clientAleatoireRes ? clientAleatoireRes : 0}</h3>
                                        <p className="text-bold" >Clients en attente</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-hourglass-start" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-success link">
                                    <div className="inner">
                                        <h3>{tauxClientFidele ? tauxClientFidele : 0}<sup>%</sup></h3>
                                        <p className="text-bold" >Taux de fidélité</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-heart" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title"><i className="fas fa-list mr-2 text-white titleIcon"></i>Liste des client fideles</h3>
                                        <span style={{ position: 'relative', float: 'right' }}>Total : <strong>{filteredData.length}</strong></span>
                                    </div>
                                    <div className="card-body">
                                        <form className="form filtre align-items-center d-flex flex-wrap justify-content-between">
                                            <div className="mb-3">
                                                <label htmlFor="orderOption" className="form-label">Trier par..</label>
                                                <select
                                                    className="optionSelect"
                                                    value={sortOrder}
                                                    onChange={(e) => setSortOrder(e.target.value)}
                                                    id='orderOption'
                                                >
                                                    <option value="">---</option>
                                                    <option value="asc">Ordre croissant</option>
                                                    <option value="desc">Ordre décroissant</option>
                                                </select>
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor="filterOption" className="form-label">Filtrer par..</label>
                                                <select
                                                    className="optionSelect"
                                                    value={sortFilter}
                                                    onChange={(e) => setSortFilter(e.target.value)}
                                                    id='filterOption'
                                                >
                                                    <option value="">---</option>
                                                    <option value="nom">Nom</option>
                                                    <option value="prenom">Prénom</option>
                                                    <option value="localisation">Localisation</option>
                                                </select>
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor="genderOption" className="form-label">Sexe..</label>
                                                <select
                                                    className="optionSelect"
                                                    value={sortGender}
                                                    onChange={(e) => setSortGender(e.target.value)}
                                                    id='genderOption'
                                                >
                                                    <option value="">---</option>
                                                    <option value="masculin">Masculin</option>
                                                    <option value="feminin">Féminin</option>
                                                </select>
                                            </div>

                                            <div className="mb-3">
                                                <input
                                                    className='optionSelect search'
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    value={searchText}
                                                    onChange={handleSearch}
                                                />
                                            </div>
                                        </form>
                                        <DataTable
                                            columns={columns}
                                            data={filteredData}
                                            striped
                                            highlightOnHover
                                            customStyles={customStyles}
                                            pagination
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* modals */}
            {/* add client modal */}
            {isModalAddOpen && (
                <div className="modal fade" id="modal-add">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Ajouter un client</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <form className="row form" onSubmit={handleClient}>
                                <div className="modal-body">
                                    <div className="container">
                                        <div className="row ">
                                            <p className='fs-4'>Veillez remplir les champs suivants pour creer un client.
                                                Les champs marqués d'un astérisque <span className="text-danger taille_etoile">(*)</span> sont obligatoires.
                                            </p>
                                            <div className="col-md-6">
                                                <label htmlFor="nom" className="form-label" >
                                                    Nom du client
                                                    <span className="text-danger taille_etoile">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="nom"
                                                    className="form-control no-focus-outline mb-2"
                                                    id="nom"
                                                    value={client.nom} onChange={onChangeAdd}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="prenom" className="form-label">
                                                    Prénom
                                                    <span className="text-danger taille_etoile">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control no-focus-outline mb-2"
                                                    id="prenom" name="prenom"
                                                    value={client.prenom} onChange={onChangeAdd}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="localisation" className="form-label">
                                                    Localisation
                                                    <span className="text-danger taille_etoile">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control no-focus-outline mb-2" id="localisation"
                                                    name="localisation"
                                                    value={client.localisation} onChange={onChangeAdd}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="numeroTel" className="form-label">
                                                    Téléphone
                                                    <span className="text-danger taille_etoile">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control no-focus-outline mb-2"
                                                    id="numeroTel"
                                                    name="numeroTel"
                                                    value={client.numeroTel} onChange={onChangeAdd}
                                                />
                                            </div>

                                            <div className="col-md-12">
                                                <label htmlFor="sexe">
                                                    Sexe
                                                    <span className="text-danger taille_etoile">*</span>
                                                </label>
                                                <select className="form-control mb-2" id='sexe' name='sexe' onChange={onChangeAdd} autoComplete='off' >
                                                    <option value="" className='text-success' disabled selected>Selectionner votre sexe</option>
                                                    <option value="masculin">Masculin</option>
                                                    <option value="feminin">Feminin</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mt-3">
                                            <button type="button" className="btn btn-secondary btn-sm" data-dismiss="modal" title='Fermer'><i className='fas fa-times f-3 mr-1'></i>Fermer</button>
                                            <div className="d-flex">
                                                {
                                                    wait ?
                                                        <button type="submit" className="btn btn-success btn-sm" title='Enregistrer le client'> <i className='fas fa-plus mr-1 f-3'></i>Enregistrer</button>
                                                        :
                                                        <button className="btn btn-success btn-sm"> <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Enregistrement..</button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* client detail modal */}
            <div className="modal fade" id="modal-detail">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title modal-title-sm">Détail du clienttt  : <strong className='ml-2 capitalize'>{clientd.nom + " " + clientd.prenom}</strong> </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button></div>
                        <div className="modal-body">
                            <div className="container">
                                <div className="row ">
                                    <div className="col-md-7 shadow text-center qr-container">
                                        <div className="qr-code-container">
                                            <QRCode
                                                className='link qr-code'
                                                value={clientInfo}
                                                size={256}
                                                style={{ width: '100%', height: '300px' }}

                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-5">
                                        {/* <div className="texte ">Bonjours tous le monda , c'est</div> */}
                                        <div className="fw-bold name mt-2"><h4><strong className='capitalize shadow px-2 py-2'>{clientd.nom + " " + clientd.prenom}</strong></h4></div>

                                        <div className="mt-3"><i className='fas fa-map-marker-alt mr-2 ml-2'></i>{clientd.localisation}</div>

                                        <div className="mt-3"><i className='fas fa-phone mr-2 ml-2'></i> (+237) {clientd.numeroTel} </div>

                                        {/* <div className="mt-3"><i className='fas fa-dumbbell mr-2 ml-2'></i> {clientd.intervention2} <strong>Kg</strong></div> */}

                                        <div className="mt-3"><i className={typeIntervention === 2 ? "fas fa-dumbbell mr-2 ml-2" : "fas fa-infinity mr-2 ml-2"}></i> {clientd.intervention} <strong>{typeIntervention === 1 ? "Visite(s)" : "Kg"}</strong></div>

                                        <div className="mt-3">
                                            {
                                                clientd.sexe === 'masculin' ? <i className="fas  mr-2 ml-2 fa-mars"></i> :
                                                    clientd.sexe === 'feminin' ? <i className="fas  mr-2 ml-2 fa-venus"></i> : ''
                                            }
                                            {clientd.sexe}
                                        </div>

                                        <div className="mt-3 "> Bonus atteint : <strong className='text-success'>{clientd.bonus}</strong> Fois</div>
                                        {/* <div className="mt-3 ml-2"><span className={clientd.statut ===  ? "badge badge-success" : "badge badge-danger"}>{clientd.bonus === true ? "Activé" : "Désactivé"}</span></div> */}

                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <div className="modal-footer  justify-content-between">
                            <button className="btn btn-secondary btn-sm" data-dismiss="modal" title='Fermer'><i className="fas fa-times mr-1"></i>Fermer</button>
                            <div className="btn">
                                <button type="button" className="btn btn-primary btn-sm ml-2" title="Ajouter un nouveau client" data-toggle="modal" data-target="#modal-add" data-dismiss="modal">
                                    <i className="fas fa-plus mr-1" ></i>
                                    Ajouter
                                </button>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanyDashboad;